<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch:{
    '$route'(to){
      this.$store.commit("setRouter",to.path);
      // sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    }
  },
  computed: {
    // 获取字典列表数据
    dictionaryList () {
      return this.$store.getters.getDictionaryList
    }
  },
  async created() {
    this.global.SET_sessionStorage();
    if ( document.cookie ) {
      // 获取字典列表数据
      await this.$store.dispatch('fetchDictionaryList', { page: 1, size: 1000 })
    }
  }
}
</script>

<style>
  @import  './style/public.css';
  @import  './style/font/iconfont.css';
  *{
    margin: 0;
    padding: 0;
  }
  #app {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  
</style>
